import React from 'react'
import { Box, Theme, useTheme } from '@mui/material'
import ReactQuill from 'react-quill'
import './styles/quill.dark.css'
import './styles/quill.snow.css'
import { useSelector } from 'react-redux'
import { getPrefersDarkMode } from '../../store/settings/settings.selectors'
import LabelWithTooltipComponent from './LabelWithTooltipComponent'

export interface IRTEProps {
  value?: string
  label?: string
  tooltip?: string
  height?: string
  required?: boolean
  disabled?: boolean
  onChange: (value: string | undefined) => void
}

const RichTextEditorComponent: React.FC<IRTEProps> = (props) => {
  const useDarkMode = useSelector(getPrefersDarkMode)
  const theme: Theme = useTheme()

  return (
    <Box sx={{ position: 'relative' }}>
      {props.label &&
        <Box sx={{
          position: 'absolute',
          backgroundColor: 'white',
          padding: '5px',
          top: '-14px',
          left: '10px',
        }}
        >
          <LabelWithTooltipComponent
            label={props.label}
            description={props.tooltip}
          />
        </Box>}
      <ReactQuill
        className={useDarkMode ? 'dark' : ''}
        defaultValue={props.value}
        readOnly={props.disabled}
        modules={{
          toolbar: [[{ header: [1, 2, 3, false] }, 'bold', 'italic', 'underline', 'strike', 'blockquote', { color: [] }, { list: 'ordered' }, { list: 'bullet' }, { script: 'sub' }, { script: 'super' }]],
        }}
        theme='snow'
        onChange={(value?: string) => {
          props.onChange(value)
        }}
        style={{
          color: theme.palette.text.primary,
          borderTop: '1px solid #ccc',
          borderBottom: '1px solid #ccc',
          marginTop: '8px',
          height: props.height || 'auto',
        }}
      />
    </Box>
  )
}
export default RichTextEditorComponent
